module.exports = __webpack_public_path__ + "media/images/games/35reveal/duck-ab5f4c27357300ad77139dd8debff3ba.png";